jQuery(document).ready(function ($) {
    function updateSubmenuPositions() {
        $('.menu-item').each(function (index) {
            var $left = $(this).offset().left;
            $(this).find('.submenu--mega').css('left', -$left);
        });
    }

    updateSubmenuPositions();

    $(window).resize(function () {
        updateSubmenuPositions();
    });

    // Seleziona gli elementi del livello 1 e 2
    const submenuLev1Links = $('.submenu-lev-1 .menu-item-link');
    const submenuLev2Links = $('.submenu-lev-2 .menu-item-link');

    // Seleziona le immagini del livello 1 e 2
    const lev1Images = $('.submenu-immagine__lev-1 .immagine-menu');
    const lev2Images = $('.submenu-immagine__lev-2 .immagine-menu');

    // Gestisci l'uscita dal sottomenu
    $('.submenu').on('mouseleave', function() {
        resetHoverStates();
    });

    // Funzione per resettare gli hover quando si esce dal menù principale
    function resetHoverStates() {
        submenuLev1Links.removeClass('active hover-active');
        submenuLev2Links.addClass('hide');
        submenuLev1Links.find('.immagine-menu').addClass('hide');
        lev1Images.addClass('hide');
        lev2Images.addClass('hide');
        activeLev1Index = null;
        activeLev2Index = null;

        console.log('resetHoverStates')
    }

    // Aggiungi l'evento mouseleave al menù principale
    $('.menu').on('mouseleave', resetHoverStates);

    let menuTimeout;
    let $currentOpenItem;

    $('.menu-item').on('mouseenter', function() {
        clearTimeout(menuTimeout);
        if ($currentOpenItem && !$.contains(this, $currentOpenItem[0])) {
            $currentOpenItem.removeClass('hover');
            $currentOpenItem.parents('.menu-item').removeClass('hover');
        }

        $currentOpenItem = $(this);
        $(this).addClass('hover');

        // $(this).parents('.menu-item').addClass('hover');
    }).on('mouseleave', function() {
        const $menuItem = $(this);
        menuTimeout = setTimeout(function() {
            $menuItem.removeClass('hover');
            $menuItem.find('.menu-item').removeClass('hover');
            $currentOpenItem = null;
        }, 200);
    });

});
